// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"PlayerProjections__wrapper--feaxW","weekDropdown":"PlayerProjections__weekDropdown--3DZee","label":"PlayerProjections__label--1K7vH","positionsWrapper":"PlayerProjections__positionsWrapper--3xeH7","collapsed":"PlayerProjections__collapsed--aZiYf","tableWrapper":"PlayerProjections__tableWrapper--1Mdbl","togglesContainer":"PlayerProjections__togglesContainer--2-OD7"};


//////////////////
// WEBPACK FOOTER
// ./src/app/views/PlayerProjections/PlayerProjections.css
// module id = A/0R
// module chunks = 7